import { connect } from 'react-redux';
import PlanningBoardMenu from '../components/planning-board-menu';
import { setViewMode, setFullScreen } from './planning-board-actions';

const mapStateToProps = state => ({
  viewMode: state.planningBoard.viewMode,
  fullScreen: state.planningBoard.fullScreen,
});

const mapDispatchToProps = {
  setViewMode,
  setFullScreen,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanningBoardMenu);
